<ng-container *ngIf="clutchStatus$ | async as clutchStatus">
  <div class="banner-container">
    <div class="recalculate-notice">
      <app-body-md bold ink="ink-85">Notice:</app-body-md>
      <app-body-md ink="ink-85">
        {{ getNotice({ isPayrollLocked: clutchStatus.isPayrollLocked, canRecalculate }) }}
      </app-body-md>
    </div>
    <app-button
      *ngIf="canRecalculate && !clutchStatus.isPayrollLocked"
      tid="recalculate-payroll"
      theme="primary-action"
      type="button"
      (click)="recalculatePayroll(clutchStatus.payrollIdentifier)"
    >
      Recalculate
    </app-button>
  </div>
</ng-container>
